import { useState } from "react";
import { MdOutlineKeyboardArrowRight, MdOutlineKeyboardArrowDown } from "react-icons/md"
const Accordion = ({ items }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleClick = (index) => {
        const previousActiveIndex = activeIndex;
        setActiveIndex(index);
        if (previousActiveIndex === index) {
            setActiveIndex(-1);
        }
    };

    return (
        <div className="accordion duration-1000">
            {items.map((item, index) => (
                <div className="accordion my-3" key={item.title}>
                    <h3 className={activeIndex === index ? `text-xl cursor-pointer flex items-center justify-between` : "text-xl cursor-pointer flex items-center justify-between"}
                        onClick={() => handleClick(index)}
                    >
                        <span>{item.title}</span>
                        {activeIndex === index ? <MdOutlineKeyboardArrowDown /> : <MdOutlineKeyboardArrowRight />}
                    </h3>
                    <div
                        className={
                            activeIndex === index
                                ? `block font-Krub font-medium text-sm text-gray rounded-md py-4`
                                : `hidden`
                        }
                    >
                        {item.content}
                    </div>
                </div>
            ))}
        </div>
    );
}
export default Accordion;